const log = {
    invalid_type: 'O tipo de registro é inválido.',
    invalid_time_window: '`end_time` deve ser posterior a `start_time`.',
};
export default Object.freeze(log);
